import { CalendarCheck } from "lucide-react";
import { featuredHighlights } from "./data";

const FEATURED_IMG = "https://images.pexels.com/photos/31043312/pexels-photo-31043312.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const FeaturedCare = () => (
    <section id="featured-care" className="bg-white py-20 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div data-testid="featured-care-content">
                <p className="text-xs font-bold uppercase tracking-[0.22em] text-teal-600 mb-4">Featured Dental Care</p>
                <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">
                    Complete Care for a Healthier Smile
                </h2>
                <p className="mt-5 text-base leading-relaxed text-slate-600">
                    Good oral health is built in three steps: preventing problems before they start, restoring teeth
                    that need attention, and refining your smile so you feel confident sharing it.
                </p>

                <div className="mt-8 space-y-5" data-testid="featured-care-highlights">
                    {featuredHighlights.map((f) => (
                        <div key={f.title} className="flex gap-4">
                            <span className="h-12 w-12 rounded-xl bg-teal-50 flex items-center justify-center shrink-0">
                                <f.icon className="h-6 w-6 text-teal-600" strokeWidth={1.5} />
                            </span>
                            <div>
                                <h3 className="text-base font-semibold text-slate-900">{f.title}</h3>
                                <p className="mt-1 text-sm leading-relaxed text-slate-500">{f.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <a
                    href="#appointment"
                    data-testid="featured-care-consultation-btn"
                    className="mt-9 inline-flex items-center gap-2 rounded-full bg-teal-600 px-7 py-3.5 text-sm font-semibold text-white shadow-[0_10px_28px_rgba(13,148,136,0.35)] transition-all duration-200 hover:bg-teal-700 hover:-translate-y-0.5"
                >
                    <CalendarCheck className="h-4 w-4" />
                    Book a Consultation
                </a>
            </div>

            <div className="relative" data-testid="featured-care-image-wrapper">
                <div className="absolute -inset-4 rounded-[2rem] bg-teal-50 rotate-2" aria-hidden="true" />
                <img
                    src={FEATURED_IMG}
                    alt="Dental professional at The Tooth Care Dental Clinic"
                    className="relative rounded-3xl object-cover w-full h-[320px] sm:h-[420px] lg:h-[500px] shadow-[0_20px_50px_rgba(2,44,40,0.14)]"
                    loading="lazy"
                />
            </div>
        </div>
    </section>
);
